import React, { useState, useEffect, FC } from 'react';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Input,
} from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';

type TenderingManagerFilterDialogProps = {
  onClose: () => void;
  open: boolean;
  onDismiss: (filterValue?: string) => void;
  column: string;
}

const TenderingManagerFilterDialog: FC<TenderingManagerFilterDialogProps> = ({
  onClose,
  open,
  onDismiss,
  column,
}) => {
  const [filter, setFilter] = useState('');

  useEffect(() => {
    if (!open) {
      setFilter('');
    }
  }, [open]);

  const handleIncludeFilter = () => {
    if (filter.trim()) {
      onDismiss(`${column}+${filter}`);
    }
  };

  const handleExcludeFilter = () => {
    if (filter.trim()) {
      onDismiss(`${column}-${filter}`);
    }
  };

  const handleClose = () => {
    onDismiss();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleIncludeFilter();
    } else if (e.key === 'Escape') {
      handleClose();
    }
  };

  return (
    <Dialog modalType="alert" open={open} onOpenChange={(_event, data) => data.open && onClose()}>
      <DialogSurface style={{ maxWidth: '500px' }}>
        <DialogBody>
          <DialogTitle
            action={
              <Button
                appearance='subtle'
                size='small'
                aria-label="close"
                icon={<Dismiss24Regular />}
                onClick={handleClose}
              />
            }
          >
            Filter {column}
          </DialogTitle>
          <DialogContent>
            <Input
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Enter filter value"
              style={{ width: '100%', margin: '15px 0px' }}
            />
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={handleExcludeFilter}>
              Dölj
            </Button>
            <Button appearance="primary" onClick={handleIncludeFilter}>
              Visa
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default TenderingManagerFilterDialog;
